import React from "react";
import PropTypes from "prop-types";

import MainWrap from "../view/MainWrap";
import { ButtonSmallLink } from "../view/Form";
import Table from "../components/Table";
import Menu from "../components/Menu";
import { request } from "../components/Utils";

import { Button } from "../components/Modal";

import CloseIcon from "../img/CloseIcon.svg";
import DownloadIcon from "../img/DownloadIcon.svg";

const Main = ({ app }) => {
  const [reloadTable, setReloadTable] = React.useState(+new Date());

  const removeGame = async (id) => {
    await request({
      url: "/api/game/remove/",
      params: {
        method: "POST",
        body: {
          id,
        },
      },
      app: app,
    });
    setReloadTable(+new Date());
  };

  return (
    <MainWrap app={app} panel="main">
      <Menu app={app} />
      <Table
        source="/api/game/my/"
        app={app}
        rows={10}
        reload={reloadTable}
        footerActions={
          app.current.user.role === "admin" ? (
            <Button
              data-type="green"
              onClick={() => {
                window.location.href = `/api/game/download?token=${app.current.token}`;
              }}
              data-max-w="210"
              data-mx="0"
              data-mb="0"
            >
              <img
                src={DownloadIcon}
                alt="Download icon"
                data-mr="10"
                style={{ verticalAlign: "text-bottom" }}
              />
              Выгрузить результат
            </Button>
          ) : null
        }
        fields={
          app.current.user.role === "admin"
            ? [
                {
                  key: "name",
                  name: "Имя и фамилия",
                  render: (row) => <>{`${row.name} ${row.surname}`}</>,
                },
                {
                  key: "started_at",
                  name: "Создан",
                  render: (row) => (
                    <>
                      {new Date(row.started_at).toLocaleDateString("ru-ru", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}{" "}
                      {new Date(row.started_at).toLocaleTimeString("ru-ru")}
                    </>
                  ),
                },
                {
                  key: "score",
                  name: "Финансовый результат",
                  render: (row) => (
                    <>
                      {row.score !== undefined &&
                      row.score !== null &&
                      row.score > 0
                        ? row.score.toLocaleString("ru-RU")
                        : "—"}
                    </>
                  ),
                },
              ]
            : [
                {
                  key: "score",
                  name: "Рейтинг",
                  bold: true,
                  render: (row) => (
                    <>
                      {row.score !== undefined &&
                        row.score !== null &&
                        row.score.toLocaleString("ru-RU")}
                    </>
                  ),
                },
                {
                  key: "started_at",
                  name: "Создан",
                  render: (row) => (
                    <>
                      {new Date(row.started_at).toLocaleDateString("ru-ru", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })}{" "}
                      {new Date(row.started_at).toLocaleTimeString("ru-ru")}
                    </>
                  ),
                },
                {
                  key: "status",
                  name: "Статус",
                  smallName: "",
                  noPadding: true,
                  render: (row) => (
                    <>
                      {row.status === 0 && (
                        <ButtonSmallLink to={`/cp/game/${row.id}`}>
                          Играть
                        </ButtonSmallLink>
                      )}
                      {row.status === 1 && (
                        <ButtonSmallLink to={`/cp/game/${row.id}`}>
                          Посмотреть
                        </ButtonSmallLink>
                      )}
                      <Button
                        data-type="redBg"
                        onClick={() => removeGame(row.id)}
                        data-m="0"
                        data-ml="10"
                        data-h="40"
                        data-w="40px"
                        data-px="0"
                      >
                        <img src={CloseIcon} alt="Close icon" />
                      </Button>
                    </>
                  ),
                },
              ]
        }
      />
    </MainWrap>
  );
};

Main.propTypes = {
  app: PropTypes.object.isRequired,
};

export default Main;
